/**
 * Lucide Icons Initialization
 * Replaces emoji-based icons with SVG icons from Lucide
 */

import { createIcons, icons } from 'lucide';

/**
 * Initialize all Lucide icons on the page
 */
export function initIcons() {
  createIcons({
    icons: icons,
    attrs: {
      'stroke-width': 1.5,
      'aria-hidden': 'true'
    }
  });
}

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initIcons);
} else {
  initIcons();
}
